<template>
  <div class="btnExistenciaClass">
    <div class="btnExistenciasSesionOn" v-if="session">
      <div v-if="isDetail" class="existencias-div">
        <p class="existencias-p">
          <strong v-if="isExistencias" class="existencias-strong">
            Existencias:
            <v-progress-circular
              v-if="loaderExistencias"
              indeterminate
              color="#ff9800"
              :width="1.5"
              :size="15"
            >
            </v-progress-circular>
            {{ ` ${Existencias}` }} disponibles)
          </strong>
        </p>
      </div>

      <div v-if="!isDetail">
        <div class="existencias-p">
          <p class="existencias-p existencias-strong" v-if="!loaderExistencias">
            {{ ` ${Existencias}` }}
          </p>

          <v-progress-circular
            v-if="loaderExistencias"
            indeterminate
            color="#ff9800"
            :width="1.5"
            :size="15"
          >
          </v-progress-circular>
        </div>
      </div>
    </div>

    <div class="btnExistenciasSesionOff" v-if="!session">
      <!-- Solicitud de inicio de sesion si no hay una session activa -->
      <v-dialog v-if="!session" v-model="dialog" persistent max-width="900px">
        <template v-slot:activator="{ on }">
          <v-btn v-show="!showExistencias" outlined color="orange" v-on="on">
            Ver Existencias
          </v-btn>
        </template>

        <!-- Registro -->
        <v-card>
          <v-card-title>
            <span class="headline">Verificar Existencias</span>
          </v-card-title>

          <v-card-text>
            <login></login>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import login from "./../views/user-views/login.vue";
import register from "./../views/user-views/register.vue";

export default {
  name: "btnExistencias",

  components: {
    login,
    register,
  },

  data() {
    return {
      session: false,
      existencias: "",
      showExistencias: false,
      dialog: false,
      loaderExistencias: true,
      isExistencias: true,
    };
  },

  props: {
    itemId: { type: String },
    isDetail: { type: Boolean },
    snackbar: { type: Function },
  },

  methods: {
    getExistence: function (itemId) {
      var baseURL = "https://market.risoul.com.mx/api/product/existencias";

      this.$http({
        method: "get",
        url: `${baseURL}/${itemId}`,
      }).then(
        (response) => {
          this.isExistencias = !response.body.existencias == 0;
          this.existencias = !this.isExistencias
            ? "Agotado"
            : response.body.existencias;
          this.loaderExistencias = false;
          this.showExistencias = true;
        },
        (error) => {
          this.snackbar(
            `Hubo un problema al obtener la existencia del producto`,
          );
          this.loaderExistencias = false;
          console.error(error);
        },
      );
    },
  },

  computed: {
    Existencias() {
      return this.existencias > 0
        ? `${this.existencias} Disponibles`
        : `Agotado`;
    },
  },

  watch: {},

  created: function () {
    if (localStorage.token) this.session = true;
    if (this.session == true) this.getExistence(this.itemId);
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--default {
  height: 28px;
  padding: 0 4px;
}

.v-btn.v-size--default,
.v-btn.v-size--large {
  font-size: 1.2rem;
}

.btnExistenciasSesionOn {
  display: inline-block;
}

.btnExistenciaClass {
  display: inline-block;
}

.btnExistenciasSesionOff {
  display: inline-block;
}

.existenciasClass ::v-deep input {
  text-align: center;
}

.existenciasClass {
  transform: scale(0.8);
  transform-origin: left;
}

.existencias-p {
  line-height: 1.8rem;
  text-align: center;
  padding: 0;
  margin: 0;
  width: 120px;
}

.existencias-strong {
  font-weight: 500;
  color: #1649b6;
}

.headline {
  font-size: 2rem !important;
  line-height: 2.25rem !important;
}
</style>
